import { render, staticRenderFns } from "./HotelFestivePriceList.vue?vue&type=template&id=2c954495&"
import script from "./HotelFestivePriceList.vue?vue&type=script&lang=js&"
export * from "./HotelFestivePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports